import axios from 'axios';
import { createActionType } from 'utils/redux';
import {
  apiGetReportSequences,
  apiGetReportAccounts,
  apiGetReportOpportunities,
} from 'constants/apiRouting';
import qs from 'qs';
import { GET_ANALYTICS } from 'constants/analytics';

import { handleErrors } from '../../utils/api';
import { API_CONFIG } from '../../constants/config';
import { analyticsTrack } from '../../utils/analytics';

export const GET_REPORT_PENDING = 'GET_REPORT_PENDING';
export const GET_REPORT_FAIL = 'GET_REPORT_FAIL';
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';

export const GET_REPORT_MANAGERS_PENDING = 'GET_REPORT_MANAGERS_PENDING';
export const GET_REPORT_MANAGERS_FAIL = 'GET_REPORT_MANAGERS_FAIL';
export const GET_REPORT_MANAGERS_SUCCESS = 'GET_REPORT_MANAGERS_SUCCESS';

export const GET_REPORT_CAMPAIGNS_PENDING = 'GET_REPORT_CAMPAIGNS_PENDING';
export const GET_REPORT_CAMPAIGNS_FAIL = 'GET_REPORT_CAMPAIGNS_FAIL';
export const GET_REPORT_CAMPAIGNS_SUCCESS = 'GET_REPORT_CAMPAIGNS_SUCCESS';

export const GET_REPORT_TEMPLATES_PENDING = 'GET_REPORT_TEMPLATES_PENDING';
export const GET_REPORT_TEMPLATES_FAIL = 'GET_REPORT_TEMPLATES_FAIL';
export const GET_REPORT_TEMPLATES_SUCCESS = 'GET_REPORT_TEMPLATES_SUCCESS';

export const RESET_REPORT = 'RESET_REPORT';

export const GET_REPORT_SEQUENCES = createActionType('GET_REPORT_SEQUENCES');
export const GET_REPORT_ACCOUNTS = createActionType('GET_REPORT_ACCOUNTS');
export const GET_REPORT_OPPORTUNITIES = createActionType('GET_REPORT_OPPORTUNITIES');

export const resetReport = () => async (dispatch) => {
  dispatch({
    type: RESET_REPORT,
    payload: {},
  });
};

export const getReport = (params = { search: null, account__id: null }) => async (dispatch) => {
  analyticsTrack(GET_ANALYTICS, params, true);
  dispatch({
    type: GET_REPORT_PENDING,
    payload: {},
  });
  try {
    const response = await axios.get(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}reports/`,
      {
        params,
        withCredentials: true,
        paramsSerializer: p => qs.stringify(p),
      },
    );
    dispatch({
      type: GET_REPORT_SUCCESS,
      payload: response.data,
      params,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};


export const getReportManagers = (params = { search: null, account__id: null }) => async (dispatch) => {
  dispatch({
    type: GET_REPORT_MANAGERS_PENDING,
    payload: {},
  });
  try {
    const response = await axios.get(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}reports/managers`,
      {
        params,
        withCredentials: true,
        paramsSerializer: p => qs.stringify(p),
      },
    );
    dispatch({
      type: GET_REPORT_MANAGERS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const getReportCampaigns = (params = { search: null, account__id: null }) => async (dispatch) => {
  dispatch({
    type: GET_REPORT_CAMPAIGNS_PENDING,
    payload: {},
  });
  try {
    const response = await axios.get(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}reports/campaigns`,
      {
        params,
        withCredentials: true,
        paramsSerializer: p => qs.stringify(p),
      },
    );
    dispatch({
      type: GET_REPORT_CAMPAIGNS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};

export const getReportSequences = (params = { search: null, account__id: null }) => async (dispatch) => {
  dispatch({
    type: GET_REPORT_SEQUENCES.name,
    payload: axios.get(
      apiGetReportSequences(),
      {
        params,
        withCredentials: true,
        paramsSerializer: p => qs.stringify(p),
      },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const getReportOpportunities = (params = { search: null, account__id: null }) => async (dispatch) => {
  dispatch({
    type: GET_REPORT_OPPORTUNITIES.name,
    payload: axios.get(
      apiGetReportOpportunities(),
      {
        params,
        withCredentials: true,
        paramsSerializer: p => qs.stringify(p),
      },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const getReportAccounts = (params = { search: null, account__id: null }) => async (dispatch) => {
  dispatch({
    type: GET_REPORT_ACCOUNTS.name,
    payload: axios.get(
      apiGetReportAccounts(),
      {
        params,
        withCredentials: true,
        paramsSerializer: p => qs.stringify(p),
      },
    ).catch(error => handleErrors(error, dispatch)),
  });
};

export const getReportTemplates = (params = { search: null, account__id: null }) => async (dispatch) => {
  dispatch({
    type: GET_REPORT_TEMPLATES_PENDING,
    payload: {},
  });
  try {
    const response = await axios.get(
      `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}reports/templates`,
      {
        params,
        withCredentials: true,
        paramsSerializer: p => qs.stringify(p),
      },
    );
    dispatch({
      type: GET_REPORT_TEMPLATES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    handleErrors(error, dispatch);
  }
};
